import classnames from 'classnames';
import { arrayOf, bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';
import { Input, InputGroup } from 'reactstrap';

class ExtendableInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { focused: false };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleFocus(event) {
    this.setState({ focused: true });
    this.props.onFocus(event);
  }

  handleBlur(event) {
    this.setState({ focused: false });
    this.props.onBlur(event);
  }

  render() {
    const {
      addons,
      bsSize,
      onChange,
      onFocus,
      onBlur,
      showAddon,
      value,
      length,
      ...rest
    } = this.props;
    const actualLength = value.length;
    const isLimitExceeded = actualLength > length;
    const { focused } = this.state;
    return (
      <InputGroup size={bsSize}>
        <Input
          className={
            length
              ? classnames({
                  'border-danger': isLimitExceeded,
                  'text-danger': isLimitExceeded,
                })
              : ''
          }
          onChange={onChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          value={value}
          {...rest}
        />
        {showAddon &&
          addons.map((Addon, index) => (
            <Addon
              key={index} // eslint-disable-line react/no-array-index-key
              focused={focused}
              actualLength={actualLength}
              length={length}
              isLimitExceeded={isLimitExceeded}
              {...rest}
            />
          ))}
      </InputGroup>
    );
  }
}

ExtendableInput.propTypes = {
  addons: arrayOf(func.isRequired),
  bsSize: string,
  value: oneOfType([number, string]),
  length: number,
  onChange: func.isRequired,
  onBlur: func,
  onFocus: func,
  showAddon: bool,
};

ExtendableInput.defaultProps = {
  addons: [],
  value: '',
  length: 0,
  bsSize: undefined,
  onBlur: () => {},
  onFocus: () => {},
  showAddon: true,
};

export default ExtendableInput;
